import { useState } from 'react';
import { useTranslation } from "react-i18next";
import { Button, Divider, Modal, CardContent, Table, TableBody, TableCell, TableContainer, TableRow, TableHead, Box, FormControl } from '@mui/material';
import MainCard from 'components/MainCard';
import { getEquipmentsByQuery } from 'components/axios/equipmentAxios';
import { useEffect } from 'react';
import PageInfo from 'components/PageInfo';
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import { useEnumApi } from 'contexts/EnumApiContext';
import CustomEnumSelect from 'components/select/CustomEnumSelect';
import CustomSelect from 'components/select/CustomSelect';
import { ROLE } from 'data/data';

export function EquipmentListLayer({excludeId, equipmentCtgrId, changeEquipment}) {
  // const isViewCommError = process.env.REACT_APP_SHOW_NETWORK_ERROR_TO_ALL_YN === 'Y';

  const { getEnumValueByEnumNameAndCode, getEnumValueByEnumName, role } = useEnumApi();
  const { t } = useTranslation();

  //modal 관련
  const { openModal } = useModals();
  
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [pageInfo, setPageInfo] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(process.env.REACT_APP_DEFAULT_PAGE_SIZE);
  
  const [equipments, setEquipments] = useState([]);

  const handlePaging = (value) => {
    value = isNaN(value) ? 1 : value;
    setCurrentPage(value-1);
  }

  useEffect(()=>{
    if (open) {
      equipmentList();
    }
  },[currentPage, open]);

  const handleSearch = (event) => {
    event.preventDefault();
    setCurrentPage(0);
    pageInfo.number = 0;
    setPageInfo(pageInfo);
    console.log('search')
    equipmentList(0);
  };

  const equipmentList = async(curPage=currentPage) => {
    isNaN(curPage) && setCurrentPage(0);
    isNaN(pageSize) && setPageSize(process.env.REACT_APP_DEFAULT_PAGE_SIZE);
    setCurrentPage(curPage)
    let param = {
      "equipmentCtgr.id" : equipmentCtgrId,
      page : curPage,
      size : pageSize
    };
    await getEquipmentsByQuery(param).then((data)=>{
      if (data != null) {
        if(data.page) {
          setPageInfo(data.page);
        } else {
          setCurrentPage(0);
          pageInfo = {
            size : pageInfo.size,
            totalElements : 0,
            totalPages : 0,
            number : 0
          }
          setPageInfo(pageInfo);
        }
        if(data._embedded) {
          setEquipments(data._embedded.equipments);
        } else {
          setEquipments([]);
        }
      }
    });
  }

  const selectEquipment=(id)=>{
    openModal(modals.confirmModal, {
      onSubmit : (value) => {
        changeEquipment(id);
        setOpen(false);
      },
      onClose : () => {
          console.log('close');
      },
      message: t('message.common.alert.source.spec.delete.rewrite.apply.question'),
    });
  }

    return (
    <>
      <Button variant="outlined" style={{padding:"2px 5px"}} color="primary" onClick={handleOpen} >{t('message.common.btn.get')}</Button>

      <Modal className="pop_box" open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <MainCard title={t('message.common.chip.equipment.list')} modal darkTitle content={false}>
          <div style={{marginTop:"-40px", marginRight:"12px", textAlign:"right"}}>
            <Button variant="contained" color="primary" size="small" onClick={handleClose}>
              {t('message.common.btn.close')}
            </Button>
          </div>
          <CardContent>

            <TableContainer>
            <Table sx={{ minWidth: 1200 }} aria-label="simple table" className="list_table pop_table">
                <TableHead>
                  <TableRow>
                    <TableCell className="th" align="center">No.</TableCell>
                    <TableCell className="th" align="center">{t('message.common.subtitle.opStatus')}</TableCell>
                    <TableCell className="th" align="center">{t('message.common.subtitle.recent.inspection')}</TableCell>
                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.level3')}</TableCell>
                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.name')}</TableCell>
                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.number')}</TableCell>
                    <TableCell className="th" align="center">{t('message.common.subtitle.position')}</TableCell>
                    <TableCell className="th" align="center">{t('message.common.subtitle.status')}</TableCell>
                    <TableCell className="th" align="center">{t('message.common.subtitle.select')}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {equipments && equipments.map(function(item,i) {
                    return (
                    <TableRow key={i}>
                      <TableCell>{pageInfo.totalElements-((currentPage)*pageInfo.size)-i}</TableCell>
                      <TableCell>
                        {/* {(((isViewCommError || role === ROLE.SA.code) && item.hasCommunicationIssue) ? t('message.common.subtitle.communication.issue') : getEnumValueByEnumNameAndCode("EquipmentOpStatus", item.opStatus)?.[0]?.title)} */}
                        {item.opStatus && getEnumValueByEnumNameAndCode("EquipmentOpStatus", item.opStatus)?.[0]?.title}
                      </TableCell>
                      <TableCell>{item.latestCommYmd}&nbsp;</TableCell>
                      <TableCell>{item.equipmentCtgr && item.equipmentCtgr.name}</TableCell>
                      <TableCell>{item.name}</TableCell>
                      <TableCell>{item.equipmentNo}</TableCell>
                      <TableCell>{item.location}</TableCell>
                      <TableCell>{item.status && getEnumValueByEnumNameAndCode("EquipmentFaultStatus", item.status)?.[0]?.title}</TableCell>
                      <TableCell>
                        {(excludeId !== item.id) &&
                        <Button variant="contained" size='small' color="primary" onClick={()=>{selectEquipment(item.id)}}>{t('message.common.btn.get')}</Button>
                        }&nbsp;
                      </TableCell>
                    </TableRow> 
                    )
                  })}
                </TableBody>
              </Table>
            </TableContainer>

            <PageInfo pageInfo={pageInfo} handlePaging={handlePaging}/>

          </CardContent>
          <Divider />

        </MainCard>
      </Modal>
    </>
    )
}

export default EquipmentListLayer;
